/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TestGuardrailsRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  testGuardrailsRequest: components.TestGuardrailsRequest;
};

/** @internal */
export const TestGuardrailsRequest$inboundSchema: z.ZodType<
  TestGuardrailsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  TestGuardrailsRequest: components.TestGuardrailsRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "TestGuardrailsRequest": "testGuardrailsRequest",
  });
});
/** @internal */
export type TestGuardrailsRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  TestGuardrailsRequest: components.TestGuardrailsRequest$Outbound;
};

/** @internal */
export const TestGuardrailsRequest$outboundSchema: z.ZodType<
  TestGuardrailsRequest$Outbound,
  z.ZodTypeDef,
  TestGuardrailsRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  testGuardrailsRequest: components.TestGuardrailsRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    testGuardrailsRequest: "TestGuardrailsRequest",
  });
});

export function testGuardrailsRequestToJSON(
  testGuardrailsRequest: TestGuardrailsRequest,
): string {
  return JSON.stringify(
    TestGuardrailsRequest$outboundSchema.parse(testGuardrailsRequest),
  );
}
export function testGuardrailsRequestFromJSON(
  jsonString: string,
): SafeParseResult<TestGuardrailsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TestGuardrailsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TestGuardrailsRequest' from JSON`,
  );
}
